import type {CouponStatusValue} from '../../../types';

import {Button, Modal} from '@ds/components';

type CouponActionModalProps = {
  status?: CouponStatusValue | string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const CouponActionModal: React.FC<CouponActionModalProps> = ({
  status,
  loading,
  onClose,
  onConfirm
}) => {
  const isRemoving = status === 'draft';
  const title = isRemoving ? 'حذف کوپن؟' : 'توقف کوپن؟';
  const description = isRemoving
    ? 'امکان بازگرداندن کوپن در صورت حذف آن وجود نخواهد داشت.'
    : 'از توقف کوپن اطمینان دارید؟';

  return (
    <Modal
      show={status === 'draft' || status === 'active'}
      onClose={onClose}
      defaultHeader
      title={title}
      footer={
        <div className="flex justify-between gap-3 border-t border-gray-03 px-4 py-3">
          <Button variant="ghost" color="secondary" onClick={onClose}>
            انصراف
          </Button>
          <Button color="destructive" loading={loading} onClick={onConfirm}>
            {isRemoving ? 'حذف' : 'توقف'}
          </Button>
        </div>
      }
    >
      <p className="px-4 py-3 text-body-sm text-neutral-fg">{description}</p>
    </Modal>
  );
};

export default CouponActionModal;
